import { NgModule } from '@angular/core';

import {UiRadioButtonComponent} from './radio-button.component';

@NgModule({
  declarations: [UiRadioButtonComponent],
  imports: [
  ],
  exports: [UiRadioButtonComponent]
})
export class UiRadioButtonModule { }
